import * as React from "react";

function HelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M16 4C9.372 4 4 9.372 4 16s5.372 12 12 12 12-5.372 12-12S22.628 4 16 4zM2 16C2 8.268 8.268 2 16 2s14 6.268 14 14-6.268 14-14 14S2 23.732 2 16zm12.5 7c0-.828.667-1.5 1.49-1.5h.02c.823 0 1.49.672 1.49 1.5s-.667 1.5-1.49 1.5h-.02c-.823 0-1.49-.672-1.49-1.5zM13 13a3 3 0 113.743 2.908C15.915 16.117 15 16.852 15 18v2h2v-1.999a.143.143 0 01.028-.039.443.443 0 01.209-.116A5.002 5.002 0 0016 8a5 5 0 00-5 5v1h2v-1z",
    clipRule: "evenodd"
  }));
}

export default HelpIcon;